import React, { useEffect, useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { handleCookies } from "./cookies";
import { useDispatch, useSelector } from "react-redux";
import { setAuthData } from "../redux/features/authSlice";
import axios from "axios";
import { baseUrl } from "../config/constants";

function Auth() {
  const [isAuth, setIsAuth] = useState(null);
  const dispatch = useDispatch();
  const reduxPermissions = useSelector((state) => state.auth.userDetails.permissions);

  useEffect(() => {
    const authCheck = async () => {
      const { token, user_name, user_role } = handleCookies.fetchCookies();

      if (!token) {
        setIsAuth(false);
      } else {
        // If permissions are already in Redux (from redux-persist), use them
        if (reduxPermissions && reduxPermissions.length > 0) {
          dispatch(
            setAuthData({
              token,
              user_name,
              user_role,
              user_permissions: reduxPermissions,
            }),
          );
          setIsAuth(true);
        } else {
          // Otherwise, fetch permissions from backend
          try {
            const response = await axios.post(
              `${baseUrl}/auth/user`,
              {},
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              },
            );

            if (response.data && response.data.data && response.data.data[0]) {
              const userData = response.data.data[0];
              dispatch(
                setAuthData({
                  token,
                  user_name,
                  user_role,
                  user_permissions: userData.user_permissions || [],
                  user_id: userData.user_id,
                  company_id: userData.company_id,
                  company_name: userData.company_name,
                }),
              );
            } else {
              dispatch(
                setAuthData({
                  token,
                  user_name,
                  user_role,
                }),
              );
            }
            setIsAuth(true);
          } catch (error) {
            console.error("Error fetching user permissions:", error);
            // Still allow auth even if permissions fetch fails
            dispatch(
              setAuthData({
                token,
                user_name,
                user_role,
              }),
            );
            setIsAuth(true);
          }
        }
      }
    };

    authCheck();
  }, [dispatch, reduxPermissions]);

  if (isAuth === null) return null;

  return isAuth ? <Outlet /> : <Navigate to="/signin" />;
}

export default Auth;
